
import { LayoutDummy } from "@libs/interfaces/dummies";

import { default as UUID } from "node-uuid"
import { Color, ID, IDictionary, ILayoutData, URL } from "src/libs/interfaces/layouts";
import { create } from "zustand";
import { createJSONStorage, devtools, persist } from 'zustand/middleware';

export function getStorage() {
    return localStorage
}

export interface IApolloState { 
    client: any
    setClient : () => any, 
    getClient: () => any
}
export interface ITheme {
    name: THEME_NAMES 
}
export interface IUser {
    id: ID
    first_name?: string
    last_name?: string
    display_name?: string
    avatar?: URL
    roles: string[]
    external?: string
    externalId?: string
    post_content?: string
    email?: string
    email_notification?: boolean
    is_accessed_cookies?: boolean
    [partName: string]: any
}

export enum NOTIFICATION_ADMIN_MODE {
    ONLY_MINE,
    ALL
}

export interface ICookieDelay {
    user_id: number
    delay: number
}

export enum THEME_NAMES {
    DAY     = 'day',
    NIGHT   = 'night',
    EVENING = 'evening'
}
export interface IState {
    version: string
    accessCookiesDelay: ICookieDelay[]
    user: IUser
    anonymUser: IUser
    setUser : (user:IUser) => void 
    getAnonymUser : () => IUser 
    accessToken: string 
    layout: ILayoutData
    config: any
    theme: THEME_NAMES 
    location: string
    landId: ID 
    event_types: string[]
    setTheme: ( theme: THEME_NAMES ) => void
    pageCount: number
    setPageCount: ( pageCount: number ) => void
    current: number
    isGlleryFullSize: boolean
    isGalleryOpenPics: boolean
    dictionary: IDictionary,
    dictionary_version: number
    isOpenLogin: boolean
    attachmentFilter: any
    notificationAdminMode: NOTIFICATION_ADMIN_MODE
}
export const useMainStore: any = create( devtools( persist<IState>( (set: any, get: any ) => ({
        version: "",
        accessCookiesDelay: [],
        user: { } as IUser, 
        anonymUser: {} as IUser,
        setUser: (user:IUser) => set( () => ({ user : user || {} }) ), 
        getAnonymUser: () : IUser => {
            if( !useMainStore.getState().anonymUser.id ) {
                useMainStore.setState({
                    anonymUser : {
                        id: UUID.v4(),
                        display_name: "Anonym User",
                    }
                })
            }
            return useMainStore.getState().anonymUser
        },
        layout: LayoutDummy(),
        config: {}, 
        theme: THEME_NAMES.DAY,
        location: "",
        landId: -1,
        accessToken: "",
        event_types: [],
        setTheme: (theme: THEME_NAMES) => set(() => ({ theme })),
        pageCount : 33,
        setPageCount: ( pageCount: number ) => set( () => ({ pageCount }) ),
        current: -1,
        isGlleryFullSize: false,
        isGalleryOpenPics: false,
        dictionary: {},
        dictionary_version: 0,
        isOpenLogin: false,
        attachmentFilter: {},
        notificationAdminMode: NOTIFICATION_ADMIN_MODE.ONLY_MINE
    }),
    {
        name: 'pe-main-storage', 
        storage: createJSONStorage( getStorage ), 
    } 
)))
export const useAppoloStore: any = create ( devtools((set: any, get: any ) => ({
        client: { },
        setClient: ( client: any ) => set( ( ) => ({ client }) ),
        getClient : () => get().client,
        connectFailedCount: 0
    })
) ) 
 

export const withStore = ( ChildComponent:any  ) => (props: object )  => {
    const storeObj:any = useMainStore(); 
    return <ChildComponent {...props} store={storeObj} /> 
};

export interface ILayoutStore {
    headerHeight: number
    footerHeight: number
    fixMobileTop: boolean,
    title: string,
    description: string,
    icon: URL,
    isLayoutLoading: boolean,
}
export const useLayoutStore : any = create( 
    devtools<ILayoutStore>(  
        (set: any, get: any ) => ({
            headerHeight: 0,
            footerHeight: 0,
            fixMobileTop: false,
            isLayoutLoading: false,
            title: "",
            description: "",
            icon: "",
        }) 
    ) 
)

export const SORT_ORDER_ASC = "asc"
export const SORT_ORDER_DESC = "desc"
export enum SORT_ORDER {
    ASC = SORT_ORDER_ASC,
    DESC = SORT_ORDER_DESC
}
 
export interface IIfaceProps {
    newMessageText: string
    setNewMessageText: (newMessageText: string) => void
    newMessageParent: ID
    setNewMessageParent: (newMessageParent: ID) => void
    players: any[]
}
export const useIfaceStore: any = create( devtools<IIfaceProps>( (set: any, get: any ) => ({
        newMessageText: "",
        setNewMessageText: ( newMessageText: string ) => set( () => ({ newMessageText }) ),
        newMessageParent: "0",
        setNewMessageParent: (newMessageParent: ID) =>  set( () => ({ newMessageParent }) ),
        players: []
    })
))